// ABOUTME: The app's one dialog for deleting a calendar item: the plain question, or how many messages go with the
// ABOUTME: item — asked from anywhere through askDeleteItem, and locked while the delete the person agreed to runs.
import { useTranslation } from "react-i18next"
import { CConfirmModal } from "@shared/ui"
import { useDeleteQuestion } from "./deleteQuestion"

export function DeleteItemQuestion() {
  const { t } = useTranslation()
  const { messageCount, isDeleting, answer } = useDeleteQuestion()
  return (
    <CConfirmModal
      isShow={messageCount !== null || isDeleting}
      title={t("common.confirmText")}
      description={messageCount ? t("discussion.deleteItemMessages", { count: messageCount }) : undefined}
      confirmText={t("discussion.delete")}
      confirmColor="red"
      isProcessing={isDeleting}
      onSuccess={() => answer(true)}
      onClose={() => {
        if (!isDeleting) answer(false)
      }}
    />
  )
}
